<template>
  <div>
    <CRow>
      <CCol col="12">
        <CCard>
          <CCardHeader>
            <div>
              <strong v-if="status_form==0">افزودن فروشگاه</strong>
              <strong v-if="status_form!=0">ویرایش</strong>
            </div>
            <div>
              <CButton v-if="status_form==0" @click="login()" type="submit" ref="submit_form" size="sm"
                       color="primary">
                <CIcon name="cil-check-circle"/>
                افزودن فروشگاه
              </CButton>
              <CButton v-if="status_form!=0" @click="login()" type="submit" ref="submit_form" size="sm"
                       color="primary">
                <CIcon name="cil-check-circle"/>
                ویرایش فروشگاه
              </CButton>

            </div>

          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol col="12 col-sm-4">
                <CInput
                    v-model="title"
                    class="required"

                    label="نام فروشگاه"
                    vertical
                />
              </CCol>
              <CCol col="12 col-sm-4">
                <CInput
                    v-model="code"
                    class="required"

                    label="کد"
                />
              </CCol>
              <CCol col="12 col-sm-4" v-if="status_form==0">
                <CInput
                    v-model="phone"
                    class="required"

                    label="شماره مدیر"
                />
              </CCol>
              <CCol col="12 col-sm-4" v-if="status_form==0">
                <CInput
                    v-model="agent_name"
                    class="required"

                    label="نام مدیر"
                />
              </CCol>
              <CCol col="12 col-sm-4" v-if="status_form==0">
                <CInput
                    v-model="admin_password"
                    class="required"

                    label="پسورد مدیر"
                />
              </CCol>
              {{ plan }}
              <CCol col="12 col-sm-4">
                <CSelect
                    :value.sync="plan"
                    :options="[{label:'مستقل 1 ساله',value:1},{label:'سالن 6 ماهه',value:2},{label:'سالن 1 ساله',value:3}]"
                    label="پلن"
                />
              </CCol>
              <CCol col="12 col-sm-4">
                <CInputCurrency
                    v-model="salary_price"
                    class="required"

                    label="هزینه سالیانه"
                />
              </CCol>
{{expire_date}}
              <CCol col="12 col-sm-4">
                <date-picker
                    label="تاریخ انقضا"
                    v-model="expire_date"
                />
              </CCol>
              <CCol col="12 col-sm-4">
                <CInput
                    v-model="max_lines"

                    label="محدودیت کاربر | لاین"
                />
              </CCol>

              <CCol col="12 col-sm-4">
                <CInput
                    v-model="sms_credit"
                    label="اعتبار پیامک"
                />
              </CCol>
              <CCol col="12 col-sm-4">
                <CInput
                    v-model="country_code"
                    label="کد کشور"
                />
              </CCol>

              <CCol col="12 col-sm-4">
                <CSelect
                    :value.sync="send_reserve_sms_to_admin"
                    class="required"
                    :options="[{label:'ندارد',value:0},{label:'دارد',value:1}]"
                    label="پیامک به مدیر"
                />
              </CCol>

              <CCol col="12 col-sm-4">
                <CSelect
                    :value.sync="send_reserve_sms_to_user"
                    class="required"
                    :options="[{label:'ندارد',value:0},{label:'دارد',value:1}]"
                    label="پیامک به مشتری"
                />
              </CCol>


            </CRow>
            <CRow>

            </CRow>
            <hr>


          </CCardBody>
        </CCard>

      </CCol>
    </CRow>


  </div>

</template>

<script>
import axios from "axios";

import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload)
import VueUploadMultipleImage from 'vue-upload-multiple-image'


import Vue from "vue";

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import moment from 'moment-jalaali';
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import editorjs from "@/views/includes/editorjs.vue";
// import  Readability from "@/plugins/readability";

const simulateAsyncOperation = fn => {
  setTimeout(fn, 200)
}

export default {
  name: 'Login',
  components: {
    editorjs,
    Treeselect,
    VueUploadMultipleImage,
  },
  data() {

    return {
      phone: '',
      agent_name: '',
      address: '',
      admin_password: '',
      loaded_page: false,
      content_json: "",
      content_text: '',
      content_html: '',
      salary_price: '',
      has_order: 0,
      expire_date: '',
      max_lines: '3',
      plan: '',
      send_reserve_sms_to_admin: 1,
      send_reserve_sms_to_user: 1,
      sms_credit: '500',
      country_code: 'ir',

      previewImage: null,
      gallery: [],

      title: '',
      code: '',

      show_gallery: true,
      status_form: 0,

    }
  },
  mounted() {
    this.loaded_page = false
this.admin_password = Math.floor(100000 + Math.random() * 900000)
    console.log("mounted called")
    var self = this
    if (self.$route.params.market_id != null) {
      self.status_form = self.$route.params.market_id;
      self.get_post_info();
    } else {
      setTimeout(function () {
        self.loaded_page = true

      }, 300)
    }
    this.plan = 1
  }, watch: {
    'plan': function () {

      if (this.plan == 1) {
        this.sms_credit = '200';
        this.salary_price = '1400000';
        this.expire_date = moment().add(365, 'day').format('YYYY-MM-DD');
        this.max_lines = '1';

      }
      if (this.plan == 2) {
        this.sms_credit = '200';
        this.salary_price = '2000000';
        this.expire_date = moment().add(180, 'day').format('YYYY-MM-DD');
        this.max_lines = '3';

      }
      if (this.plan == 3) {
        this.sms_credit = '500';
        this.salary_price = '3800000';
        this.expire_date = moment().add(365, 'day').format('YYYY-MM-DD');
        this.max_lines = '3';

      }
    }

  },
  methods: {


    get_post_info() {
      var self = this;
      var formData = new FormData();
      formData.append("market_id", self.status_form)
      axios.post('/api/super-admin/markets/get_market_info', formData, {}).then(function (response) {
        var post_data = response.data;

        self.title = post_data.config.title.title
        self.code = post_data.config.market_code
        self.phone = post_data.config.title.phone
        // self.agent_name= post_data.config.
        // self.admin_password= post_data.config.
        self.address = post_data.config.title.address
        self.expire_date = post_data.config.expire_date
        self.max_lines = post_data.config.max_lines
        self.plan = post_data.config.plan
        self.send_reserve_sms_to_admin = post_data.config.send_reserve_sms_to_admin
        self.send_reserve_sms_to_user = post_data.config.send_reserve_sms_to_user
        self.sms_credit = post_data.config.sms_credit
        self.country_code = post_data.config.country_code


        self.loaded_page = true
        if (self.$route.params.clone_product_id != null) {
          self.status_form = 0
        }
      }).catch(function (error) {
        console.log(error);
      });


    },


    login() {

      let self = this;
      const formData = new FormData()
      let url;
      if (self.status_form == 0) {
        url = "/api/super-admin/markets/add_market";
      } else {
        url = "/api/super-admin/markets/edit_market";
        formData.append('market_id', this.status_form)

      }


      formData.append('title', this.title);
      formData.append('code', this.code);
      formData.append('phone', this.phone);
      formData.append('agent_name', this.agent_name);
      formData.append('admin_password', this.admin_password);
      formData.append('plan', this.plan);
      formData.append('salary_price', this.salary_price);
      formData.append('max_lines', this.max_lines);
      formData.append('sms_credit', this.sms_credit);
      formData.append('expire_date', this.expire_date);
      formData.append('send_reserve_sms_to_admin', this.send_reserve_sms_to_admin);
      formData.append('send_reserve_sms_to_user', this.send_reserve_sms_to_user);


      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);
        if (self.status_form == 0) {
          alert('password is '+this.admin_password)
          self.name = '';
          self.mobile = '';
          self.email = '';
          self.description = '';
          self.password = '';
          self.product_price = '';
          self.product_stock = '';
          self.product_off_price = '';
          self.order_point = 0;
          self.product_off_price_date = '';
          if (res.data.error == 0) {
            self.$router.push({path: "/dashboard/markets/list/"})
          }
        } else {
          self.get_post_info()
        }

      }).catch(function (error) {

        console.log(error);
      });

    }
  }
}


</script>
<style>

</style>
